import { loginSuccess } from '@/features/auth/model/authSlice';
import { store } from './providers';

export const initAuth = () => {
    const token = localStorage.getItem('access_token');
    const userStr = localStorage.getItem('user');

    if (token && userStr) {
        try {
            const user = JSON.parse(userStr);
            store.dispatch(loginSuccess({ token, user }));
        } catch (e) {
            console.error('Ошибка при инициализации токена:', e);
        }
    }
};
